import styled, { css } from 'styled-components';
import { colors, isDefaultThemeMode } from 'core/theme';

const accessibilityColors = (props) => {
  if (!isDefaultThemeMode(props)) {
    return css`
      color: ${colors.text};

      &:hover,
      &:active {
        background-color: ${colors.text};
        color: ${colors.background};

        svg path {
          fill: ${colors.background};
        }
      }
    `;
  }
}

const ButtonStylerGrey = styled.div`
  & > button {
    color: ${colors.B54};
    font-weight: 400;
    margin: 0;

    & > span:not(:first-child) {
      margin-left: 0.5em;
      margin-right: 0;
    }

    &:hover {
      color: ${colors.B87};
    }

    &:active {
      background-color: ${colors.HIGHLIGHT};
      color: ${colors.B87};
    }

    ${accessibilityColors};
  }
`;

export default ButtonStylerGrey;



// WEBPACK FOOTER //
// ./src/elements/Button/styled/ButtonStylerGrey.js